import jwtDecode from 'jwt-decode';

export default (token) => {
  const decodedToken = jwtDecode(token);
  return decodedToken;
};
